// utils/vue-core.ts
import { createApp, Component, App } from 'vue';
import { pinia } from './pinia';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import Tooltip from 'primevue/tooltip';
import KeyFilter from 'primevue/keyfilter';
import PopupMainNavbar from '../components/navbar/PopupMainNavbar.vue';
import PopupAffiliateNavbar from '../components/navbar/PopupAffiliateNavbar.vue';
import PopupWalletNavbar from '../components/navbar/PopupWalletNavbar.vue';
import PopupPromotionNavbar from '../components/navbar/PopupPromotionNavbar.vue';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Toast from 'primevue/toast';
import FocusTrap from 'primevue/focustrap';
import ConfirmDialog from 'primevue/confirmdialog';
const appInstances: Record<string, App> = {};

export const mountVueComponent = (
	component: Component,
	props: Record<string, any>,
	containerId: string,
) => {
	const el = document.getElementById(containerId);
	if (!el) return;

	// เก็บกวาด app เก่าที่อาจค้างอยู่ (เช่นตอน SweetAlert2 แทนที่ popup โดยไม่ยิง willClose)
	// ถ้าไม่ unmount ออก ConfirmDialog เก่าจะยัง .on() ค้างบน global ConfirmationEventBus
	// ของ PrimeVue → confirm.require() ครั้งเดียวเด้ง dialog ซ้อนกันหลายอัน
	Object.keys(appInstances).forEach((id) => {
		if (id !== containerId) unmountVueComponent(id);
	});

	const app = createApp(component, props);

	app.directive('tooltip', Tooltip);
	app.directive('keyfilter', KeyFilter);
	app.directive('focustrap', FocusTrap);

	app.use(pinia);
	app.use(PrimeVue, {
		theme: {
			preset: Aura,
			options: {
				darkModeSelector: false,
			},
		},
	});
	app.use(ToastService)
	app.use(ConfirmationService)

	app.component('PopupMainNavbar', PopupMainNavbar);
	app.component('PopupWalletNavbar', PopupWalletNavbar);
	app.component('PopupAffiliateNavbar', PopupAffiliateNavbar);
	app.component('PopupPromotionNavbar', PopupPromotionNavbar);
	app.component('Toast', Toast);
	app.component('ConfirmDialog', ConfirmDialog);
	app.mount(el);
	appInstances[containerId] = app;
};

export const unmountVueComponent = (containerId: string) => {
	const app = appInstances[containerId];
	if (app) {
		app.unmount();
		delete appInstances[containerId];
	}

	const el = document.getElementById(containerId);
	if (el) el.innerHTML = '';
};
